// extracted by mini-css-extract-plugin
export default {"newIncidentPopover":"popover_newIncidentPopover__9qhxa","searchPopover":"popover_searchPopover__8HgQt"};